import { ContentService } from '@blk/cwp-ng-framework';
import { AbstractRenderer, BusinessComponent, BusinessComponentOptions } from '@blk/simba';
import { ASSET_CLASS_ORDER } from '@ddt-web/common';
import { ColorsConfig } from '@ddt-web/config';
import { InjectConfig, ModelsExperienceConfigKey, SharedConfigKey } from '@ddt-web/config-layer';
import { ComponentData, DateFormatter, TabUtil } from '@ddt-web/data-service';
import { DateUtil, NumberUtil } from '@ddt-web/generic-utils';
import { AggregatedPortfolioComposition, DisclosureComponent, HeadingLevel, HeadingWithDateComponent } from '@ddt-web/pdf-components';
import * as get from 'lodash/get';

import { HoldingsTableUtil } from '../helpers';

export class FamilyChangesToHoldingsComponent extends BusinessComponent {

	@InjectConfig(ModelsExperienceConfigKey.DATE_FORMAT) private readonly dateFormat: string = DateUtil.MODELS_US_DATE_FORMAT;
	@InjectConfig(ModelsExperienceConfigKey.USE_H1_TITLE_PDF) private readonly useH1Title: boolean = false;
	@InjectConfig(SharedConfigKey.ASSET_CLASS_COLORS) private readonly assetClassColors = ColorsConfig.ASSET_CLASS_COLORS;
	@InjectConfig(SharedConfigKey.ASSET_CLASS_ORDER) private readonly assetClassOrder = ASSET_CLASS_ORDER;
	@InjectConfig(ModelsExperienceConfigKey.ENABLE_PDF_HOLDINGS_HEADER_WRAPPING) private readonly enableHeaderWrapping: boolean = false;

	constructor(name: string, public dataComponentId: string, public visible: boolean = true, public modelNames: string[] = [], public asOfDate: string) {
		super(name, 'BusinessComponent', BusinessComponentOptions.merge({ visible: visible, componentId: dataComponentId }));
		this.modelNames = ['', ...this.modelNames];
	}

	public isComponentDataVisible(componentData: ComponentData): boolean {
		const changesTabFlag = componentData && componentData.getTabById('changesToHoldingsFlag');
		const hasNoPreviousHoldingsFlag = get(changesTabFlag, 'tableData[0].cells', []).some(row => get(row, '0.rawValue', false));
		return componentData && componentData.success && !hasNoPreviousHoldingsFlag;
	}

	public buildComponent(componentData: ComponentData, contentSvc: ContentService): AbstractRenderer<SVGGElement>[] {
		if (this.isComponentDataVisible(componentData)) {
			const formatter = (value: number): string => {
				return value ? NumberUtil.formatNumber(value, 1) : '-';
			};
			const transformedTabArray = new AggregatedPortfolioComposition().getTransformedTab(componentData, 'changes', formatter, this.assetClassColors, this.assetClassOrder);
			const panels: AbstractRenderer<SVGGElement>[] = [];
			const headingLevel = this.useH1Title ? HeadingLevel.H1 : HeadingLevel.H2;
			transformedTabArray.forEach(transformedTab => {
				if (TabUtil.isTabValid(transformedTab)) {
					panels.push(
						new HeadingWithDateComponent().buildHeader(
							'Heading', 'PDF_CHANGES_TO_HOLDINGS_H2',
							'Changes to Holdings (%)',
							new DateFormatter(this.dateFormat).format(this.asOfDate),
							'ALLOCATIONS_AS_OF_PDF',
							true,
							headingLevel
						)
					);
					this.modelNames = this.enableHeaderWrapping ? HoldingsTableUtil.wrapModelNames(this.modelNames) : this.modelNames;
					panels.push(HoldingsTableUtil.getHeaderRow(this.modelNames, 0));
					panels.push(...HoldingsTableUtil.getTablePanels(transformedTab, contentSvc, this.modelNames, true));
				}
			});

			panels.push(
				...[
					new DisclosureComponent(
						'CHANGES_TO_HOLDINGS_DISCLAIMER_PDF',
						'CHANGES_TO_HOLDINGS_DISCLAIMER_PDF',
						{},
						{ marginTop: 2 }
					)
				]
			);
			return panels;
		}
		return [];
	}
}
